import type React from 'react';
import { SELLER_LOGIN_SCOPE, useShortcutScope } from '@/components/shortcuts';
import { SellerLoginView } from './SellerLoginView';
import { useSellerLogin } from './useSellerLogin';

/**
 * Seller sign-in page container. Two steps — pick a seller from the branch
 * roster, then tap a 4-digit PIN. Thin composition point: logic in
 * `useSellerLogin`, render in `SellerLoginView`.
 *
 * Pushes the `sellerLogin` shortcut scope for as long as the screen is
 * mounted, on both steps: `F1` lists the sign-in keys first from either one,
 * and the PIN step's physical keys act only while it is the live scope.
 */
export const SellerLogin: React.FC = () => {
    useShortcutScope(SELLER_LOGIN_SCOPE);
    const logic = useSellerLogin();
    return <SellerLoginView {...logic} />;
};
